import TransactionalCreditContext from "../../tools/contexts/transationcalCredit/TransactionalCreditContext";
import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {divarLinkGenerator, safeRedirect} from "../../tools/helpers";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import {TransactionalCreditDefaults} from "../../tools/defaults/transactionalCredit/TransactionalCreditDefaults";
import InitConfirm from "../../components/transactionalCredit/InitConfirm";
import ProgressLoading from "../../components/loading/ProgressLoading";
import CreatePayment from "../../components/transactionalCredit/CreatePayment";
import VerifyOTP from "../../components/transactionalCredit/VerifyOTP";
import Final from "../../components/transactionalCredit/Final";
import WidgetManagement from "../../components/transactionalCredit/WidgetManagement";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import useDivarAuth from "../../hooks/useDivarAuth";

const TransactionalCredit = () => {
    const navigate = useNavigate()
    const {state} = useLocation();
    const {postToken,serviceType,returnUrl,token}=useDivarAuth();
    const redirectFromPayment = state ? state.redirectFromPayment : null
    const [pid, setPid] = useState(null);
    const [isLoading, setIsLoading] = useState({
        showLoading: true,
        loadingText: 'لطفا منتظر بمانید',
    });
    const [process, setProcess] = useState({});
    const [components, setComponents] = useState(null);
    const [widget, setWidget] = useState(null);
    useEffect(() => {
        handleInquiryProcess()
    }, []);
    const handleRedirectToDivar = ({price, status}) => {
        const link = divarLinkGenerator({
            returnUrl,
            price,
            status,

        });
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal,{
                title:'خطا',
                message:'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText:'بستن',
                onCancel:()=>{
                    Reoverlay.hideModal();
                    navigate('/404')

                }
            })
        })

    }
    const handleProcess = (newProcess) => {
        setProcess(newProcess)
    }
    const handleLoading = (newLoading) => {
        setIsLoading(newLoading)
    }
    const handleUpdateStep = (newStep, passedStep) => {
        if (passedStep) {
            let passedSteps = [...process.passed_steps, passedStep];

            const newState = {
                ...process,
                current_step: newStep,
                passed_steps: passedSteps,
            }

            setProcess(newState)
        } else {
            const newState = {
                ...process,
                current_step: newStep
            }

            setProcess(newState)
        }
    };
    const handleCreateProcess = () => {
        setWidget(null)
        localStorage.removeItem('transactional_credit_reset')
        setIsLoading({
            showLoading: true,
            loadingText: 'لطفا منتظر بمانید'
        })
        Api.post(REQUEST_URLS.TRANSACTIONAL_CREDIT.CREATE_PROCESS, {
            "post_token": postToken
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;

            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    loadingText: 'لطفا منتظر بمانید'
                })
                handleError({
                    data, status, message, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleCreateProcess();
                            }
                        })
                    }
                })
            } else {
                setIsLoading({
                    showLoading: true,
                    loadingText: 'در حال دریافت اطلاعات'
                })
                setPid(data.pid);
                handleGetProcess(data.pid)
            }
        }).catch(e => {

        }).finally(() => {

        })
    }
    const handleInquiryProcess = () => {
        setWidget(null)
        setIsLoading({
            showLoading: true,
            loadingText: 'در حال دریافت اطلاعات'
        })
        Api.get(REQUEST_URLS.TRANSACTIONAL_CREDIT.INQUIRY_PROCESS, {
            params: {
                post_token: postToken,
                service_type: serviceType
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {status, data, message, hasError} = response;
            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    loadingText: 'در حال دریافت اطلاعات'
                });

                handleError({
                    status,
                    handleRetry: handleInquiryProcess,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleInquiryProcess();
                            }
                        })
                    }
                })
            } else {
                if (data?.process && data?.process?.pid) {
                    if (data?.widget && data?.widget?.has_widget) {

                        if (data?.components?.current_component.name !== "Final") {
                            setPid(data.process.pid);
                            if (redirectFromPayment) {

                                handleGetProcess(data.process.pid)
                            } else {
                                setIsLoading({
                                    showLoading: false,
                                    loadingText: 'در حال دریافت اطلاعات'
                                });
                                setWidget(data?.widget);
                            }
                        } else {
                            setIsLoading({
                                showLoading: false,
                                loadingText: 'در حال دریافت اطلاعات'
                            })
                            setWidget(data?.widget);

                        }

                    } else {
                        setWidget(null)
                        if (data?.components?.current_component.name !== "Final") {
                            setPid(data.process.pid);
                            handleGetProcess(data.process.pid)
                        } else {
                            handleCreateProcess();
                        }

                    }
                } else {
                    handleCreateProcess();
                }
            }
        }).catch((e) => {

        }).finally(() => {

        })
    }
    const handleGetProcess = (newPid) => {
        setWidget(null)
        setIsLoading({
            showLoading: true,
            loadingText: 'در حال دریافت اطلاعات'
        });
        Api.get(REQUEST_URLS.TRANSACTIONAL_CREDIT.FETCH_PROCESS, {
            params: {
                pid: newPid
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;
            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    loadingText: 'لطفا منتظر بمانید'
                })
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleGetProcess(newPid);
                            }
                        })
                    }
                })
            } else {

                setComponents(data.components)
                setProcess(data.process);
                if (data.components.current_component.name === TransactionalCreditDefaults.SHAHKAR) {
                    setIsLoading({
                        showLoading: true,
                        loadingText: 'لطفا منتظر بمانید'
                    })
                    handleShahkar(newPid)
                } else {
                    setIsLoading({
                        showLoading: false,
                        loadingText: 'لطفا منتظر بمانید'
                    })
                }
                if (data.components.current_component.name === TransactionalCreditDefaults.TRANSACTIONAL_CREDIT_INQUIRY) {
                    localStorage.removeItem('chooseAddon');
                }


            }
        }).catch(e => {
            console.log(e)
            setIsLoading({
                showLoading: false,
                loadingText: 'لطفا منتظر بمانید'
            })
        }).finally(() => {

        })
    }
    const handleShahkar = (newPid) => {
        setIsLoading({
            showLoading: true,
            loadingText: 'در حال تطبیق کد ملی و شماره موبایل'
        })
        handleGenerateUuid('Shahkar', token).then(data => {
            setIsLoading({
                showLoading: true,
                loadingText: 'در حال تطبیق کد ملی و شماره موبایل'
            })
            Api.post(REQUEST_URLS.TRANSACTIONAL_CREDIT.SHAHKAR, {
                pid: newPid,
                uuid: data,
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(newPid)

                } else {
                    setIsLoading({
                        showLoading: false,
                        loadingText: 'در حال تطبیق کد ملی و شماره موبایل'
                    })
                    handleError({
                        message,
                        status,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای دسترسی',
                                showConfirmButton: data?.can_reset,
                                confirmButtonText: 'ویرایش اطلاعات',
                                confirmButtonTheme: "light",
                                showCancelButton: status != 360,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                pid: newPid,
                                onConfirm: () => {
                                    if (data.can_reset) {
                                        handleReset(newPid);
                                    }
                                    Reoverlay.hideModal();
                                },
                                onCancel: () => {
                                    Reoverlay.hideModal();
                                    handleShahkar(newPid);
                                }
                            })
                        }
                    })


                }

            }).catch(() => {
                handleLoading(false)
            }).finally(() => {


            })

        }).catch(error => {
            console.log(error);
            handleLoading(false)
        });

    }
    const handleReset = (newPid) => {
        setIsLoading({
            showLoading: true,
            loadingText: 'لطفا منتظر بمانید',
        });
        Api.post(REQUEST_URLS.TRANSACTIONAL_CREDIT.REST_PROCESS, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {hasError, data, message, status} = response;
            if (hasError) {
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleReset(newPid);
                                Reoverlay.hideModal();
                            }
                        })
                    }
                })
            } else {
                localStorage.setItem('transactional_credit_reset', 'Shahkar')
                handleGetProcess(newPid)
            }
        }).finally(() => {

        })
    }
    const handleError = ({onConfirm, onClose, handleRetry, message, title, pid, data, status, options, callback}) => {
        if(status===-9){
            // rate limit
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText:'بازگشت به دیوار',
                confirmButtonTheme:"red",
                onConfirm:()=>{

                    handleRedirectToDivar({
                        price:null,
                        status:'fail',
                    });
                }
            })


        }else if (status === -20) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: false,
            })
        } else if (status === 500) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای سرویس',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: handleRetry ? 'تلاش مجدد' : 'بستن',
                cancelButtonTheme: 'red',

                onCancel: () => {
                    if (handleRetry) {
                        handleRetry()
                    }

                }
            })

        } else if (status === 403 || status === 401) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'دریافت دسترسی ',
                cancelButtonTheme: 'red',
                onCancel: () => {
                    navigate('/auth/gate/v11dW62X4kaZ2Hn4/' + serviceType + '?post_token=' + postToken)

                }
            })
        } else if (status === 801 || status === 802 || status === -100 || status === 803 || status === 805 || status === -100) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'ساخت پروسه جدید',
                cancelButtonTheme: 'red',
                onCancel: () => {
                    handleCreateProcess();
                }
            })
        } else {
            callback()
        }
    }
    const handleComponents = (newComponents) => {
        setComponents(newComponents)
    }
    return <TransactionalCreditContext.Provider value={
        {
            postToken,
            isLoading,
            pid,
            token,
            process,
            components,
            handleLoading,
            handleUpdateStep,
            handleProcess,
            handleError,
            handleComponents,
            handleGetProcess,
            handleCreateProcess,
            handleReset,
            handleRedirectToDivar,

        }
    }>
        {!!widget && <WidgetManagement handleInquiry={handleInquiryProcess} widget={widget}/>}
        {!widget && <div className="min-h-screen">
            {isLoading && isLoading.showLoading &&
                <ProgressLoading showProgress={false} type="" showSpinner={true} duration={30}
                                 text={isLoading.loadingText || 'لطفا منتظر بمانید'} theme="green"/>}
            {(!isLoading || !isLoading.showLoading) && process && components?.current_component?.name === TransactionalCreditDefaults.INIT_CONFIRM &&
                <InitConfirm/>}
            {(!isLoading || !isLoading.showLoading) && process && components?.current_component?.name === TransactionalCreditDefaults.OTP_REQUEST &&
                <VerifyOTP/>}
            {(!isLoading || !isLoading.showLoading) && process && components?.current_component?.name === TransactionalCreditDefaults.OTP_VERIFY &&
                <VerifyOTP/>}
            {(!isLoading || !isLoading.showLoading) && process && components?.current_component?.name === TransactionalCreditDefaults.CREATE_PAYMENT &&
                <CreatePayment/>}
            {(!isLoading || !isLoading.showLoading) && process && components?.current_component?.name === TransactionalCreditDefaults.PAYMENT_INQUIRY &&
                <CreatePayment/>}
            {(!isLoading || !isLoading.showLoading) && process && components?.current_component?.name === TransactionalCreditDefaults.TRANSACTIONAL_CREDIT_INQUIRY &&
                <Final/>}
        </div>}
    </TransactionalCreditContext.Provider>
}
export default TransactionalCredit;